import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { EntityNumberField } from '../../common/EntityNumberField';
import { EntitySampleRangeConfigurator, EntitySampleRangeValidator } from '../../common/EntitySampleRangeConfigurator';
export const EntityNumericConfigurator = props => {
    const { picker, column, disabled, onChange } = props;
    function handlePrecisionAndScaleValue(value) {
        const min = 0;
        const max = 1000;
        if (value > max)
            value = max;
        if (value < min)
            value = min;
        return value;
    }
    return (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { item: true, xs: 12, md: 4 }, picker),
        React.createElement(Grid, { item: true, xs: 12, md: 4 },
            React.createElement(TextField, { type: 'number', fullWidth: true, disabled: disabled, size: 'small', label: 'Precision', InputProps: { inputProps: { min: 0, max: 1000 } }, variant: 'outlined', value: column.precision || '', onChange: event => {
                    const precision = handlePrecisionAndScaleValue(parseInt(event.target.value));
                    onChange(Object.assign(Object.assign({}, column), { type: 'numeric', precision }));
                } })),
        React.createElement(Grid, { item: true, xs: 12, md: 4 },
            React.createElement(TextField, { type: 'number', fullWidth: true, disabled: disabled, size: 'small', label: 'Scale', InputProps: { inputProps: { min: 0, max: 1000 } }, variant: 'outlined', value: column.scale || '', onChange: event => {
                    const scale = handlePrecisionAndScaleValue(parseInt(event.target.value));
                    onChange(Object.assign(Object.assign({}, column), { type: 'numeric', scale }));
                } }))));
};
function createMax(precision, scale = 0) {
    const n = '9'.repeat(precision - scale);
    const d = '9'.repeat(scale);
    return parseFloat(d ? `${n}.${d}` : n);
}
function validateDecimal(value, scale) {
    const [, decimal = ''] = value.toString().split('.');
    return decimal.length <= scale;
}
function validatePrecisionAndScale(value, column) {
    var _a, _b;
    const scale = (_a = column.scale) !== null && _a !== void 0 ? _a : 0;
    const precision = (_b = column.precision) !== null && _b !== void 0 ? _b : 0;
    const maxValue = createMax(precision, scale);
    const errorMessage = `Cannot be more than precision and scale (${precision}, ${scale}).`;
    return value > maxValue || !validateDecimal(value, scale)
        ? errorMessage
        : undefined;
}
function isValidNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
export const EntityNumericPlugin = {
    type: 'numeric',
    configurator: EntityNumericConfigurator,
    onRemoveColumnType: (column, index, context) => {
        const { trackChanges } = context;
        if (column.type !== 'numeric') {
            // remove column precision and scale when type is change from numeric to other type
            trackChanges.delete(`columns[${index}].precision`);
            trackChanges.delete(`columns[${index}].scale`);
        }
        return column;
    },
    validate: column => {
        if (!isValidNumber(column.precision) || !isValidNumber(column.scale)) {
            return 'Please specify a precision and scale value.';
        }
    },
    edit: {
        field: EntityNumberField,
        validateError: (column, value) => {
            if (typeof value === 'number') {
                const numericError = validatePrecisionAndScale(value, column);
                return numericError ? numericError : undefined;
            }
            return undefined;
        }
    },
    sampleData: {
        configurator: EntitySampleRangeConfigurator({ float: true }),
        defaultValue: column => {
            var _a;
            const max = createMax((_a = column.precision) !== null && _a !== void 0 ? _a : 0, column.scale);
            return { min: 0, max };
        },
        validate: (config, column) => {
            const errors = EntitySampleRangeValidator(config, column) || {};
            if (!errors.min && typeof config.min === 'number') {
                errors.min = validatePrecisionAndScale(config.min, column);
            }
            if (!errors.max && typeof config.max === 'number') {
                errors.max = validatePrecisionAndScale(config.max, column);
            }
            return errors.min || errors.max ? errors : undefined;
        }
    }
};
//# sourceMappingURL=EntityNumericPlugin.js.map